export default __webpack_public_path__ + "static/media/sideLogo.af62bde5.png";